module.exports = __webpack_public_path__ + "images/landing/video-previews/Real_Estate_2x.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/landing/video-previews/Real_Estate_2x.jpg
// module id = EJJq
// module chunks = 1